export default defineNuxtRouteMiddleware(async () => {
  const auth = useAuth()
  if (!auth.loaded.value) await auth.refresh()
  if (!auth.capabilities.value.commercialLicensing) return navigateTo('/', { replace: true })
})
